import { render } from "./PersonalDetails.vue?vue&type=template&id=1b144e24&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"

import "./PersonalDetails.vue?vue&type=style&index=0&id=1b144e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b144e24"]])

export default __exports__